/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { IntegrationConfiguration } from '../../models/integration-configuration';

export interface PosIntegrationConfigurationsProvidersPosProviderTypeIdIdVersionIdVersionIdGet$Params {
  posProviderType: string;
  id: string;
  versionId: string;
}

export function posIntegrationConfigurationsProvidersPosProviderTypeIdIdVersionIdVersionIdGet(http: HttpClient, rootUrl: string, params: PosIntegrationConfigurationsProvidersPosProviderTypeIdIdVersionIdVersionIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<IntegrationConfiguration>> {
  const rb = new RequestBuilder(rootUrl, posIntegrationConfigurationsProvidersPosProviderTypeIdIdVersionIdVersionIdGet.PATH, 'get');
  if (params) {
    rb.path('posProviderType', params.posProviderType, {});
    rb.path('id', params.id, {});
    rb.path('versionId', params.versionId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<IntegrationConfiguration>;
    })
  );
}

posIntegrationConfigurationsProvidersPosProviderTypeIdIdVersionIdVersionIdGet.PATH = '/pos-integration-configurations/providers/{posProviderType}/id/{id}/versionId/{versionId}';
